import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import EmptyStates from '../../../common/components/empty-states';
import Page from '../../../common/components/page';
import styles from './search-page.scss';

const SearchPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Page>
      <EmptyStates
        className={styles.emptyStatesContainer}
        title={t('search-page.no-results-title')}
        content={t('search-page.no-results-content')}
      />
    </Page>
  );
};

export default SearchPage;
